"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _EmbeddedVideo = _interopRequireDefault(require("./EmbeddedVideo"));

var _EmbeddedVideoInline = _interopRequireDefault(require("./EmbeddedVideoInline"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = {
  "default": _EmbeddedVideo["default"],
  inline: _EmbeddedVideoInline["default"]
};
exports["default"] = _default;